import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const NftCardSkeleton = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#1A1A1A',
        borderRadius: 2,
        transition: 'transform 0.3s, box-shadow 0.3s'
      }}
    >
      <Stack
        height="258px"
        bgcolor="#1c2833"
        alignItems="center"
        borderRadius="8px 8px 0 0"
        overflow="hidden"
        justifyContent="center"
      >
        <Skeleton variant="rectangular" width="100%" height="144px" />
      </Stack>

      <Box sx={{ p: 2 }}>
        <Skeleton variant="text" width="60%" height={28} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="40%" height={28} sx={{ visibility: 'visible' }} />
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width="30%" height={28} />
        </Box>
        <Stack spacing={2} mt={2}>
          <Skeleton variant="rectangular" width="100%" height={48} />
        </Stack>
      </Box>
    </Box>
  );
};

export default NftCardSkeleton;
